import { SET_MODULES } from 'actions/types';

export default (state = [], action) => {
  switch (action.type) {
    case SET_MODULES:
      return [...action.payload];
    default:
      return state;
  }
};
